import { render, staticRenderFns } from "./MoneyDialog.vue?vue&type=template&id=651a8f79&"
import script from "./MoneyDialog.vue?vue&type=script&lang=js&"
export * from "./MoneyDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports